import _ from "lodash";
import * as React from "react";
// translation
import {translate} from "react-i18next";
// app state and redux
import {connect} from "react-redux";
// components
import {RouteComponentProps} from "react-router";
import {
    CnrDto,
    MenuDto,
    ModeltypeBasicDto,
    ModelyearDto, ResourceListOfModeltypeBasicDto, ResourceListOfModelyearDto,
    TypefamilyDto, UserDetailsDto,
    ResourceListOfWorkflowOptionApprovalDto, WorkflowDtoType, WorkflowOptionApprovalDto, HistoryDto,
} from "../../services/Client";
// view container
import ViewContainer, {ICommonViewProps} from "../ViewContainer";
import OptionApprovalBlock from "./OptionApprovalBlock";
import {ApprovalViewHeader} from "./ApprovalViewHeader";
import {ITypefamilyMap} from "../../redux/reducers/generalReducer";
import HATEOASClient from "../../services/HATEOASClient";
import {compose, Dispatch} from "redux";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import GeneralActions from "../../redux/actions/GeneralActions";
import ApprovalViewActions from "../../redux/actions/ApprovalViewActions";
import {
    selectBaseLinks,
    selectClient,
    selectCnrList,
    selectModelyears,
    selectTypefamilyMap,
    selectUserDetails,
    selectApprovals, selectLanguage,
    selectUserPSLModelyears,
    selectUserCnrs,
    selectUserTypefamiliesMap
} from "../../redux/selectors";
import {ILocationTranslation} from "src/components/GeneralInterfaces";
import {IReduxState} from "../../redux/IReduxState";
import {HistoryDialog} from "../../components/Dialogs/HistoryDialog";
import ApprovalSelectionDialog from "./ApprovalSelectionDialog";

interface IMapStateToProps {
    client: HATEOASClient;
    userDetails?: UserDetailsDto;
    baseLinks?: MenuDto;
    modelYears?: ResourceListOfModelyearDto;
    approvals?: ResourceListOfWorkflowOptionApprovalDto;
    cnrList?: CnrDto[];
    typefamilyMap?: ITypefamilyMap;
    userLanguage: string;
    userPSLModelyears: ResourceListOfModelyearDto;
    userCnrs: CnrDto[];
    userTypefamiliesMap: ITypefamilyMap;

}

interface IMapDispatchToProps {
    addLoadingMessage: (message: string) => void;
    removeLoadingMessage: (message: string) => void;
    addTranslationLocation: (translation: ILocationTranslation) => void;
    receivedApprovals: (data?: ResourceListOfWorkflowOptionApprovalDto) => void;
    updateOpenApprovalsCount: (openApprovals: number) => void;
}

interface IApprovalViewProps extends IMapStateToProps, IMapDispatchToProps, ICommonViewProps, RouteComponentProps<any> {
}

interface IApprovalViewState {
    optionApprovals: WorkflowOptionApprovalDto[];
    filteredApprovals: WorkflowOptionApprovalDto[];
    filterValue: TypefamilyDto | undefined;
    changedApprovals: WorkflowOptionApprovalDto[];
    style: {marginTop: string};
    allApprovedToggled: boolean;
    resubmittedRequestsChecked: boolean;

    /** Show the history dialog */
    showHistoryDialogFor?: WorkflowOptionApprovalDto;

    /** Contains the history data for a selected item */
    selectedItemHistoryData?: HistoryDto[];

    fieldKeyFilters: Set<string>;

    /** Contains the filtered history data for a selected item */
    selectedItemFilteredHistoryData?: HistoryDto[];
    scrollToIndex: number;
    countList: any;
    openApprovalSelectionDialog: boolean;
    modelYearObjectId: string;
    typeFamilyObjectId: string;
}

/**
 * A container view for Approvals
 */
class ApprovalView extends React.Component<IApprovalViewProps, IApprovalViewState> {

    constructor(props: IApprovalViewProps) {
        super(props);
        this.state = {
            optionApprovals: [],
            changedApprovals: [],
            filteredApprovals: [],
            filterValue: undefined,
            style: {marginTop: '0'},
            allApprovedToggled: false,
            resubmittedRequestsChecked: false,
            showHistoryDialogFor: undefined,
            selectedItemHistoryData: undefined,
            fieldKeyFilters: new Set<string>(),
            scrollToIndex: 0,
            countList: undefined,
            openApprovalSelectionDialog: false,
            modelYearObjectId: "0",
            typeFamilyObjectId: "0"
        };
    }

    componentDidMount() {
        const { match, addTranslationLocation, modelYears } = this.props;

        // Add translation location
        addTranslationLocation({
            pattern: "approval",
            substitutes: [{ substitute: { text: "APPROVALS" } }]
        });

        // Check if URL contains modelyear and typefamily
        const { modelyear, typefamily } = match.params;

        if (modelyear && typefamily) {
            // If modelyear and typefamily are present, set them in the state and load approvals
            this.setState(
                {
                    modelYearObjectId: modelyear,
                    typeFamilyObjectId: typefamily,
                    openApprovalSelectionDialog: false
                },
                () => this.reloadApprovals()
            );
        } else {
            // If modelyear and typefamily are not present, open the selection dialog
            this.setState({ openApprovalSelectionDialog: true });
        }

        // Load approval count if baseLinks and modelYears are available
        if (this.props.baseLinks && modelYears) {
            this.getApprovalCount(modelYears);
        }
    }
    componentWillReceiveProps(nextProps: Readonly<IApprovalViewProps>, nextContext: any): void {
        if (nextProps.modelYears !== this.props.modelYears) {
          this.getApprovalCount(nextProps.modelYears);
        }
    }
    createLinkForOptionsViewInternal(modelyear: string, typefamily: string) {
        let path: string = "/approval";
        path = path.concat("/", modelyear, '/', typefamily);
        return path;
    }

    componentDidUpdate(prevProps: IApprovalViewProps, prevState: IApprovalViewState) {
        if (this.props.modelYears !== prevProps.modelYears || this.props.history.action === "POP") {
            this.reloadApprovals();
        }
        const link = this.props.match.params;
        if (this.props.history.location.pathname === "/approval" && !this.state.openApprovalSelectionDialog) {
            this.setState({openApprovalSelectionDialog: true});
            return;
        }
        if (prevState.changedApprovals !== this.state.changedApprovals) {
            this.calculateMargin();
        }

        if (prevProps.approvals !== this.props.approvals) {
            const {approvals} = this.props;
            if (!approvals || !approvals.elements) {
                this.setState({optionApprovals: []});
            } else {
                const optionApprovals = approvals.elements.filter((workflow: WorkflowOptionApprovalDto) => (
                    workflow.workflow.type === WorkflowDtoType.OPTION_PARTITION
                ));

                this.setState({
                    optionApprovals: optionApprovals,
                    filteredApprovals: optionApprovals,
                    changedApprovals: [],
                    filterValue: undefined
                });
            }
        }
    }
    getApprovalCount = (modelYears:any) => {
        const {
            addLoadingMessage,
            removeLoadingMessage,
        } = this.props;

        if (this.props.baseLinks && modelYears) {
            addLoadingMessage('Loading');
            this.props.client.GET_approvalCount(this.props.baseLinks).execute()
                .then((res: any) => {
                    this.setState({countList: res});
                    removeLoadingMessage('Loading');
                });
        }
    }

    /**
     * Reloads all approvals
     */
    reloadApprovals = (): void => {
        const { baseLinks, client, addLoadingMessage, removeLoadingMessage, t, match } = this.props;
        let { modelYearObjectId, typeFamilyObjectId } = this.state;

        // Check if modelyear and typefamily are present in the URL
        if (match.params.modelyear && match.params.typefamily) {
            modelYearObjectId = match.params.modelyear;
            typeFamilyObjectId = match.params.typefamily;
        }

        // If modelYearObjectId or typeFamilyObjectId is missing, open the selection dialog
        if (!modelYearObjectId || modelYearObjectId === "0" || !typeFamilyObjectId || typeFamilyObjectId === "0") {
            this.setState({ openApprovalSelectionDialog: true });
            return;
        }

        // Update the URL and load approvals
        const path = this.createLinkForOptionsViewInternal(modelYearObjectId, typeFamilyObjectId);
        this.props.history.replace(path);

        if (baseLinks && client.GET_approvals(baseLinks).canExecute()) {
            const loadApprovalsMessage: string = t("LOAD_BASIC_APPROVALS");
            addLoadingMessage(loadApprovalsMessage);

            client
                .GET_approvals(baseLinks)
                .execute({ modelYearObjectId: +modelYearObjectId, typeFamilyObjectId: +typeFamilyObjectId })
                .then((approvalResource: ResourceListOfWorkflowOptionApprovalDto) => {
                    removeLoadingMessage(loadApprovalsMessage);
                    this.setState({ allApprovedToggled: false, openApprovalSelectionDialog: false });

                    if (approvalResource.elements && approvalResource.elements.length > 0) {
                        this.loadModeltypes(approvalResource);
                    } else {
                        this.setState({ optionApprovals: [], filteredApprovals: [], changedApprovals: [] });
                    }

                    window.scrollTo({ top: 0, behavior: "smooth" });
                })
                .catch((reason) => {
                    removeLoadingMessage(loadApprovalsMessage);
                    renderErrorToast({
                        message: "ERRORS:GET_APPROVALS",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        } else {
            renderErrorToast({
                message: "ERRORS:MISSING_ACCESS_RIGHTS",
                details: "ERRORS:GET_APPROVALS",
                timestamp: Date.now()
            });
        }
    }

    /**
     * loads modeltypes for the given modelyears of the workflow groups
     *
     * @param approvalResource
     *        list with the retrieved approvals
     */
    loadModeltypes = (approvalResource: ResourceListOfWorkflowOptionApprovalDto): void => {
        const modelyearIdList = new Set<number>();
        const relevantMTBsMap: Map<number, ModeltypeBasicDto> = new Map();
        const {
            modelYears,
            t,
            addLoadingMessage,
            removeLoadingMessage,
            client,
        } = this.props;

        if (modelYears && modelYears.elements) {
            // @ts-ignore already checked
            approvalResource.elements.forEach(approval => modelyearIdList.add(approval.modelyear.objectId));

            // TODO not very optimal to have a call in a foreach
            // get modelyears by ids
            Array.from(modelyearIdList).forEach((id: number) => {
                // get "real" modelyearDto
                const modelyearToFetch = _.find(modelYears.elements, (modelyear: ModelyearDto) => {
                    return modelyear.objectId === id;
                });

                // if modelyear was found, get list of modeltypes
                if (modelyearToFetch) {
                    if (!client.GET_modeltypeBasicList(modelyearToFetch).canExecute()) {
                        renderErrorToast({
                            message: "ERRORS:MISSING_ACCESS_RIGHTS",
                            details: "ERRORS:GET_MODELTYPE_BASIC_LIST",
                            timestamp: Date.now()
                        });
                    } else {
                        const loadModeltypebasicMessage: string = t("APPROVAL_VIEW:LOAD_MODELTYPE_BASIC_FOR_MODELYEAR")
                            + ' ' + modelyearToFetch.mj4;
                        addLoadingMessage(loadModeltypebasicMessage);

                        client.GET_modeltypeBasicList(modelyearToFetch).execute()
                            .then((mtbResource: ResourceListOfModeltypeBasicDto) => {
                                if (mtbResource.elements) {
                                    mtbResource.elements.forEach((element: ModeltypeBasicDto) => {
                                        relevantMTBsMap.set(element.objectId, element);
                                    });
                                }

                                this.buildCompleteApprovalDtos(relevantMTBsMap, approvalResource);
                                removeLoadingMessage(loadModeltypebasicMessage);
                            })
                            .catch((reason: any) => {
                                this.buildCompleteApprovalDtos(relevantMTBsMap, approvalResource);
                                removeLoadingMessage(loadModeltypebasicMessage);

                                renderErrorToast({
                                    message: "ERRORS:GET_MODELTYPE_BASIC_LIST",
                                    translationOptions: {modelyear: modelyearToFetch.mj4},
                                    details: reason,
                                    timestamp: Date.now()
                                });
                            });
                    }
                }
            });
        }
    }

    /**
     * builds the complete approval dtos
     *
     * @param relevantMTBsMap
     *        the map with all modeltypes
     * @param approvalResource
     *        list with the retrieved approvals
     */
    buildCompleteApprovalDtos = (
        relevantMTBsMap: Map<number, ModeltypeBasicDto>,
        approvalResource: ResourceListOfWorkflowOptionApprovalDto
    ) => {
        const {cnrList, typefamilyMap, modelYears, receivedApprovals} = this.props;

        // build the cnr map
        const cnrMap: Map<number, CnrDto> = new Map();
        // @ts-ignore the user data is loaded first
        cnrList.forEach((element: CnrDto) => {
            cnrMap.set(element.objectId, element);
        });

        // @ts-ignore already checked
        approvalResource.elements.forEach(element => {
            if (element.assignedModeltypes) {
                element.assignedModeltypes = element.assignedModeltypes.map(amtb => {
                    const completeMtb = relevantMTBsMap.get(amtb.modeltypeBasic.objectId);
                    if (completeMtb) {
                        delete completeMtb.links;
                        amtb.modeltypeBasic = completeMtb;
                    }
                    return amtb;
                });
            }

            const completeCnr = Object.assign({}, cnrMap.get(element.cnr.objectId));
            delete completeCnr.links;

            element.cnr = completeCnr ? completeCnr : element.cnr;

            // @ts-ignore already checked
            const completeModelyear: ModelyearDto | undefined = modelYears.elements.find(
                (modelyearToFind: ModelyearDto) => modelyearToFind.objectId === element.modelyear.objectId);

            if (completeModelyear) {
                element.modelyear.mj1 = completeModelyear.mj1;
                element.modelyear.mj4 = completeModelyear.mj4;
            }
            if (completeModelyear) {
                if (element.typefamily && typefamilyMap && typefamilyMap[completeModelyear.mj1].elements) {
                    // @ts-ignore checked in the above if
                    const completeTypefamily = typefamilyMap[completeModelyear.mj1].elements.find((tf: TypefamilyDto) => {
                        return tf.objectId === element.typefamily.objectId;
                    });

                    element.typefamily = completeTypefamily ? completeTypefamily : element.typefamily;
                }
            }
        });

        receivedApprovals(approvalResource);
    }

    /**
     * Gets all typefamilies present in the approvals from the current instance of the approval view.
     *
     * @return A Set with all typefamilies from the approvals.
     */
    getTypefamilies = (): TypefamilyDto[] => {
        const relevantIds: number[] = [];
        const result: TypefamilyDto[] = [];

        this.state.optionApprovals.forEach(approval => {
            if (!relevantIds.includes(approval.typefamily.objectId)) {
                result.push(approval.typefamily);
                relevantIds.push(approval.typefamily.objectId);
            }
        });

        return result;
    }

    /**
     * Saves all changed approvals
     */
    onSave = (): void => {
        const {approvals, addLoadingMessage, removeLoadingMessage, t, client} = this.props;
        if (approvals && this.state.changedApprovals.length > 0) {
            const saveRequest = client.POST_approvals(approvals);
            if (saveRequest.canExecute()) {
                const saveApprovalsMessage = t("SAVE_APPROVALS");
                addLoadingMessage(saveApprovalsMessage);

                const approvalsFosUpdate = this.state.changedApprovals.map(ap => {
                    delete ap.links;
                    return ap;
                });

                saveRequest.execute(approvalsFosUpdate)
                    .then(() => {
                        removeLoadingMessage(saveApprovalsMessage);
                        this.setState({filterValue: undefined});
                        this.reloadApprovals();
                    })
                    .catch((reason: any) => {
                        removeLoadingMessage(saveApprovalsMessage);
                        this.reloadApprovals();
                        renderErrorToast({message: "ERRORS:SAVE_APPROVALS", details: reason, timestamp: Date.now()});
                    });
            }
            else {
                renderErrorToast({
                    message: "ERRORS:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:UPDATE_WORKFLOW",
                    timestamp: Date.now()
                });
            }
        }
    }
    filterRecordByChange = async (type: string, filterApprovals: WorkflowOptionApprovalDto[]) => {
        const {client, approvals, addLoadingMessage, removeLoadingMessage, t} = this.props;
        const loadApprovalsMessage: string = t("LOAD_BASIC_APPROVALS");
        addLoadingMessage(loadApprovalsMessage);
        if (approvals) {
            try {
                const optionStatusMap: any = {};
                filterApprovals.forEach((approval: any) => {
                    optionStatusMap[approval.objectId.toString()] = approval.workflowStatus;
                });
                const payload: any = {
                    optionStatusMap: optionStatusMap,
                    type
                };
                const res: any = await client.POST_filterApprovals(approvals).execute(payload);
                // res containes the objectId of the filtered approvals
                if (res) {
                    this.setState({filteredApprovals: filterApprovals.filter(approval => res.includes(approval.objectId))});
                }
                removeLoadingMessage(loadApprovalsMessage);
            } catch (reason) {
                removeLoadingMessage(loadApprovalsMessage);
                renderErrorToast({message: "ERRORS:SAVE_APPROVALS", details: reason, timestamp: Date.now()});
            }
        }
    }
    onFilterByChange = (newValue: any) => {
        window.scrollTo({top: 0, behavior: 'smooth'});
        this.setState({allApprovedToggled: false, filterValue: newValue});
        if (!newValue) {
            this.onFilterResubmittedRequestsChange(false);
            return;
        }
        const {optionApprovals} = this.state;

        switch (newValue.id) {
            case 0:
                this.filterRecordByChange('TEXT', optionApprovals);
                break;
            case 1:
                this.filterRecordByChange('ASSIGNMENT', optionApprovals);
                break;
            case 2:
                this.onFilterResubmittedRequestsChange(true);
                break;
            default:
                this.onFilterResubmittedRequestsChange(false);
                break;
        }
    }

    onFilterResubmittedRequestsChange = (checked: boolean) => {
        const {optionApprovals} = this.state;
        const approvals = optionApprovals;

        if (checked) {
            this.setState({
                filteredApprovals: approvals.filter(approval => (!(approval.prevRejectMessage === '' || !approval.prevRejectMessage))),
                resubmittedRequestsChecked: true
            });
        } else {
            this.setState({
                filteredApprovals: approvals,
                resubmittedRequestsChecked: false
            });
        }

    }

    /**
     * Clears the list of the changed approvals
     */
    clearChangedApprovals = () => {
        if (this.state.changedApprovals.length !== 0) {
            const initialOptions: WorkflowOptionApprovalDto[] = this.state.optionApprovals.map(option => {
                delete option.rejectMessage;
                delete option.approved;
                return option;
            });
            this.setState({
                optionApprovals: initialOptions,
                changedApprovals: [],
            });
        }
    }

    /**
     * Indicates if the rejected messages are valid or not
     * They must not be empty if a line is rejected!
     */
    isRejectedMessageValid = (): boolean => {
        const {changedApprovals} = this.state;
        if (changedApprovals.length > 0) {
            const isValid = changedApprovals.find((approval: WorkflowOptionApprovalDto) => (
                approval.approved === false
                && (approval.rejectMessage === undefined
                    || approval.rejectMessage === null
                    || approval.rejectMessage.trim() === "")
            ));
            return isValid === undefined;
        }
        return true;
    }

    /**
     * Is called when the approve button from an approval is pressed.
     *
     * @param approval
     *      the corresponding approval
     * @param toggled
     *      if the button is toggled or not
     */
    onApprovalApproved = (approval: WorkflowOptionApprovalDto, toggled: boolean) => {
        this.setState({allApprovedToggled: false});
        if (toggled) {
            approval.approved = true;
            delete approval.rejectMessage;
        } else {
            delete approval.approved;
            delete approval.rejectMessage;
        }
        this.updateApproval(approval);
    }

    /**
     * Is called when the reject button from an approval is pressed.
     *
     * @param approval
     *      the corresponding approval
     * @param toggled
     *      if the button is toggled or not
     */
    onApprovalRejected = (approval: WorkflowOptionApprovalDto, toggled: boolean) => {
        this.setState({allApprovedToggled: false});
        if (toggled) {
            approval.approved = false;
        } else {
            delete approval.approved;
            delete approval.rejectMessage;
        }
        this.updateApproval(approval);
    }

    /**
     * Is called when the reject message from an approval is changed.
     *
     * @param approval the corresponding approval
     * @param val - the reason for rejection
     */
    onApprovalRejectMessageEntered = (approval: WorkflowOptionApprovalDto, val: string) => {
        approval.rejectMessage = val;
        this.updateApproval(approval);
    }

    /**
     * Adds to the list of changed approvals a new approval if not exist, otherwise it updates the existing approval with new new value.
     *
     * @param approval the corresponding approval
     *
     * @return an updated list of approvals
     */
    addToChangedApprovalList = (approval: WorkflowOptionApprovalDto): WorkflowOptionApprovalDto[] => {
        let updatedChangedApprovalList: WorkflowOptionApprovalDto[] = [...this.state.changedApprovals];
        const changedApprovalIndex = updatedChangedApprovalList.findIndex((_approval: WorkflowOptionApprovalDto) => approval.objectId === _approval.objectId);

        if (changedApprovalIndex === -1) {
            updatedChangedApprovalList.push(approval);
        } else {
            updatedChangedApprovalList[changedApprovalIndex] = approval;
        }

        return updatedChangedApprovalList;
    }

    /**
     * Removes from the list of changed approvals aa approval
     *
     * @param approval the corresponding approval
     *
     * @return an updated list of approvals
     */
    removeFromChangedApprovalList = (approval: WorkflowOptionApprovalDto): WorkflowOptionApprovalDto[] => {
        return this.state.changedApprovals.filter(app => app.objectId !== approval.objectId);
    }

    /**
     *
     * Updates an approval from the current state.
     *
     */
    updateApproval = (approval: WorkflowOptionApprovalDto) => {

        let updatedApprovals: WorkflowOptionApprovalDto[] = this.state.optionApprovals;

        updatedApprovals.map((_approval) => {
            if (_approval.objectId === approval.objectId) {
                _approval = approval;
            }

            return _approval;
        });

        this.setState({
            optionApprovals: updatedApprovals,
            changedApprovals: approval.approved !== undefined ? this.addToChangedApprovalList(approval) : this.removeFromChangedApprovalList(approval)
        });
    }

    /**
     * Is called when the 'Approve All' button is clicked. It will mark as approved all (filtered) approvals from the view.
     */
    handleApproveAll = (toggled: boolean) => {
        const toApprove: WorkflowOptionApprovalDto[] = this.state.filteredApprovals;
        let changedApprovals: WorkflowOptionApprovalDto[] =
            toApprove.map((approval: WorkflowOptionApprovalDto) => {
                if (toggled) {
                    approval.approved = true;
                    delete approval.rejectMessage;
                } else {
                    delete approval.approved;
                    delete approval.rejectMessage;
                }
                return approval;
            });
        this.setState({changedApprovals: toggled ? changedApprovals : [], allApprovedToggled: toggled, filterValue: undefined});
    }

    /**
     *
     * Calculates the margin of the virtualized-list so that the header looks sticky
     *
     */
    calculateMargin = () => {
        const headerElement: HTMLElement | null = document.getElementById('approval-header');
        this.setState({style: {marginTop: headerElement ? `${headerElement.clientHeight}px` : '0'}});
    }

    private renderHistoryDlg = () => {
        const {t} = this.props;
        const {showHistoryDialogFor} = this.state;

        if (showHistoryDialogFor) {
            const {modelyear, typefamily, cnr, optionCode} = showHistoryDialogFor;

            return (
                <HistoryDialog
                    identifier={`${t("GLOBAL:MODELYEAR")}: ${modelyear.mj1} (${modelyear.mj4}) -
                                ${t("GLOBAL:TYPEFAMILY")}: ${typefamily ? typefamily.name : ''} -
                                ${t("GLOBAL:CNR")}: ${cnr ? t(`GLOBAL:${cnr.cnr}`) : ''} -
                                ${t("COLUMN_FACTORY:OPTIONCODE")}: ${optionCode}`}
                    historyData={this.state.selectedItemFilteredHistoryData || []}
                    t={this.props.t}
                    dialogTitle={"OPTION_HISTORY_TT"}
                    onClose={() => this.setState({showHistoryDialogFor: undefined, selectedItemHistoryData: undefined})}
                    filterValues={this.state.fieldKeyFilters || new Set<string>()}
                    onChangeFilterValue={(fieldKey: string) => this.onChangeFilterValue(fieldKey)}
                />
            );
        } else {
            return undefined;
        }
    }

    private onChangeFilterValue = (selectedFieldKey: string | undefined) => {
        if (selectedFieldKey !== undefined && selectedFieldKey !== '') {
            this.setState({
                selectedItemFilteredHistoryData: this.state.selectedItemHistoryData
                    && this.state.selectedItemHistoryData.filter(value => value.fieldKey === selectedFieldKey)
            });
        } else {
            this.setState({
                selectedItemFilteredHistoryData: this.state.selectedItemHistoryData
            });
        }
    }

    private createDropdownFilterValues = () => {
        const fieldKeys: Set<string> = new Set<string>();

        if (this.state.selectedItemHistoryData) {
            fieldKeys.add("");
            this.state.selectedItemHistoryData.map(data => {
                if (data.fieldKey) {
                    fieldKeys.add(data.fieldKey);
                }
            });
        }

        this.setState({fieldKeyFilters: fieldKeys});
    }

    private requestOptionHistory = (showHistoryDialogFor: WorkflowOptionApprovalDto) => {
        if (showHistoryDialogFor) {
            const {client, addLoadingMessage, removeLoadingMessage, t} = this.props;

            const getHistoryRequest = client.GET_approvalViewOptionSelfHistory(showHistoryDialogFor);
            if (!getHistoryRequest.canExecute()) {
                renderErrorToast({
                    message: 'GLOBAL:MISSING_ACCESS_RIGHTS',
                    timestamp: Date.now()
                });
                return;
            }

            const requestLoadingMessage = t('BASEOPTIONS:GET_HISTORY');
            addLoadingMessage(requestLoadingMessage);

            getHistoryRequest.execute({language: this.props.userLanguage})
                .then((returnValue: HistoryDto[]) => {
                    this.setState({
                        showHistoryDialogFor: showHistoryDialogFor,
                        selectedItemHistoryData: returnValue,
                        selectedItemFilteredHistoryData: returnValue
                    });

                    removeLoadingMessage(requestLoadingMessage);
                    this.createDropdownFilterValues();
                }).catch((reason: any) => {
                    removeLoadingMessage(requestLoadingMessage);
                    renderErrorToast({
                        message: 'ERRORS:GET_HISTORY',
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    updatedScrollIndex = (index: number) => {
        this.setState({scrollToIndex: index});
    }

    render() {
        const {t, userLanguage} = this.props;
        const {
            changedApprovals,
            optionApprovals,
            style,
            filteredApprovals,
            allApprovedToggled,
            resubmittedRequestsChecked,
            openApprovalSelectionDialog
        } = this.state;
        if (openApprovalSelectionDialog) {
            return (
                <ViewContainer>
                    {
                        this.state.countList && <ApprovalSelectionDialog
                            countList={this.state.countList}
                            userPSLModelyears={this.props.userPSLModelyears}
                            userTypefamiliesMap={this.props.userTypefamiliesMap}
                            onSelectionDialogSubmit={(modelYearObjectId: string, typeFamilyObjectId: string) => {
                                this.setState({openApprovalSelectionDialog: false, modelYearObjectId, typeFamilyObjectId});
                                setTimeout(() => this.reloadApprovals());
                            }}
                            onSelectionDialogClose={() => this.props.history.goBack()}
                        />
                    }
                </ViewContainer>
            );
        }
        return (
            <ViewContainer>
                <ApprovalViewHeader
                    hintEnabled={!this.isRejectedMessageValid()}
                    t={t}
                    allApprovedToggled={allApprovedToggled}
                    changedApprovals={changedApprovals}
                    filterDatasource={this.getTypefamilies()}
                    filterValue={this.state.filterValue}
                    handleApproveAll={this.handleApproveAll}
                    onSave={this.onSave}
                    optionApprovals={filteredApprovals}
                    resubmittedRequestsChecked={resubmittedRequestsChecked}
                    onFilterByChange={this.onFilterByChange}
                    onFilterResubmittedRequestsChange={this.onFilterResubmittedRequestsChange}
                />
                {filteredApprovals.length > 0 ?
                    <React.Fragment>

                        <OptionApprovalBlock
                            approvals={filteredApprovals}
                            userLanguage={userLanguage}
                            style={style}
                            onApprovalApproved={this.onApprovalApproved}
                            onApprovalRejected={this.onApprovalRejected}
                            onApprovalRejectMessageEntered={this.onApprovalRejectMessageEntered}
                            onClickShowHistory={(showHistoryDialogFor: WorkflowOptionApprovalDto): void => this.requestOptionHistory(showHistoryDialogFor)}
                            updatedScrollIndex={this.updatedScrollIndex}
                            scrollToIndex={this.state.scrollToIndex}
                        />
                    </React.Fragment>
                    :
                    <div
                        style={{
                            display: "flex",
                            height: "100vh",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            fontSize: 16,
                        }}
                    >
                        {t("NO_OPEN_APPROVALS")}
                    </div>
                }
                {this.state.showHistoryDialogFor && this.renderHistoryDlg()}
            </ViewContainer>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    modelYears: selectModelyears(state),
    userDetails: selectUserDetails(state),
    baseLinks: selectBaseLinks(state),
    client: selectClient(state),
    approvals: selectApprovals(state),
    cnrList: selectCnrList(state),
    typefamilyMap: selectTypefamilyMap(state),
    userLanguage: selectLanguage(state),
    userPSLModelyears: selectUserPSLModelyears(state),
    userCnrs: selectUserCnrs(state),
    userTypefamiliesMap: selectUserTypefamiliesMap(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    addLoadingMessage: (message: string) => dispatch(GeneralActions.AddLoadingMessage(message)),
    removeLoadingMessage: (message: string) => dispatch(GeneralActions.RemoveLoadingMessage(message)),
    addTranslationLocation: (translation: ILocationTranslation) => dispatch(GeneralActions.AddTranslationLocation(translation)),
    receivedApprovals: (data?: ResourceListOfWorkflowOptionApprovalDto) => dispatch(ApprovalViewActions.ReceivedApprovals(data)),
    updateOpenApprovalsCount: (openApprovals) => dispatch(ApprovalViewActions.UpdateOpenApprovalsCount(openApprovals))
});

export default compose(
    translate(["APPROVAL_VIEW", "WORKFLOW"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(ApprovalView);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/ApprovalView.tsx